module.exports = __webpack_public_path__ + "static/A2-Observer-3cca1db4e7774eabcad3f16434ffa4c2.png";